export default {"src":"/_next/static/media/loader.6570db3c.gif","height":34,"width":93,"blurWidth":0,"blurHeight":0};